import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function usePublishScheduleModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.publishScheduleModalState, ...args };
    updateGlobalState({ publishScheduleModalState: newState });
  };

  return {
    close: () => setState({ isOpen: false }),
    isOpen: state.publishScheduleModalState.isOpen,
    open: () => setState({ isOpen: true }),
  };
}
